import { on, platformModifierKey } from '@disy/lib/event-util';

import { getStore } from 'cadenza/store/cadenza-store';
import type { View } from 'cadenza/workbook/view/view';
import { hasDetailView } from 'cadenza/workbook/workbook-core-selectors.state';
import { isLinearLayout } from 'cadenza/workbook/worksheet-layout';

export function setupScrollingForSmallViewportsOnDesktop(view: View, scrollBody: HTMLElement) {
  return on(
    view,
    'wheel',
    (event) => {
      if (!isLinearLayout() || hasDetailView(getStore().getState())) {
        return;
      }
      if (!platformModifierKey(event)) {
        event.preventDefault();
        document.documentElement.scrollBy({ left: event.deltaX, top: event.deltaY, behavior: 'auto' });
        return;
      }

      if (event.shiftKey) {
        // Holding the shift key scrolls the deltaY horizontally.
        scrollBody.scrollBy({ left: event.deltaY, behavior: 'smooth' });
      } else {
        scrollBody.scrollBy({ left: event.deltaX, top: event.deltaY, behavior: 'smooth' });
      }
      event.preventDefault();
    },
    { passive: false, capture: true },
  );
}
